import {
  Dropdown,
  DropdownOption,
} from "components/designV2/dropdown/dropdown";
import { useTranslation } from "react-i18next";
import {
  PassSettingControl,
  PassSettingControls,
} from "./passSettingsV2.styled";
import { SystemSettingRow } from "./systemSettingRow.component";

export const CompanyTimeZoneSetting: React.FC<{
  value: string;
  onChange: (v: string) => void;
}> = ({ value, onChange }) => {
  const { t } = useTranslation();

  const timeZoneOptions: DropdownOption[] = [
    { label: "Europe/Stockholm", value: "Europe/Stockholm" },
  ];

  return (
    <SystemSettingRow
      title={t("System.CompanyTimeZone")}
      description={t("System.CompanyTimeZoneInfo")}
      controlVerticalAlign="center"
    >
      <PassSettingControls>
        <PassSettingControl>
          <Dropdown
            ariaLabel={t("System.CompanyTimeZone")}
            options={timeZoneOptions}
            value={value}
            onChange={onChange}
            disabled
          />
        </PassSettingControl>
      </PassSettingControls>
    </SystemSettingRow>
  );
};
